import { useFilterPermissionStore } from "presentation/stores/use-filter-permission-store";
import { Button } from "primereact/button";

/**
 * Propriedades para o componente `HeaderPermissionGrid`.
 */
interface HeaderProps {
  /** Função de callback chamada quando o botão "Nova permissão" é clicado. */
  onAdd: () => void;
}

/**
 * Componente que renderiza o cabeçalho da grelha de permissões.
 * Contém os botões de ação principais, como "Nova permissão" e "Limpar filtros".
 *
 * @param {HeaderProps} props - As propriedades do componente.
 */
const HeaderPermissionGrid: React.FC<HeaderProps> = ({ onAdd }) => {
  const { filters, setFilters, resetFilters } = useFilterPermissionStore();
  /** Reseta os filtros no store do Zustand para o seu estado inicial. */
  const clearFilter = () => {
    resetFilters();
    setFilters({
      query: { value: "", matchMode: "contains" },
      queryRole: { value: "", matchMode: "contains" },
      queryFunction: { value: "", matchMode: "contains" },
    });
  };

  return (
    <div className="flex justify-content-between">
      <div></div>
      <div style={{ display: "flex" }}>
        <Button
          type="button"
          icon="pi pi-plus"
          label="Nova permissão"
          outlined
          onClick={onAdd}
          style={{
            backgroundColor: "#2196F3",
            color: "white",
            borderRadius: "8px",
          }}
        />
        <div style={{ width: "10px" }}></div>
        <Button
          type="button"
          icon="pi pi-filter-slash"
          label="Limpar"
          outlined
          onClick={clearFilter}
          style={{
            backgroundColor: "white",
            borderColor: "#2196f3",
            color: "#2196f3",
            borderRadius: "8px",
          }}
        />
      </div>
    </div>
  );
};
export default HeaderPermissionGrid;
